import Logo from '../images/md_bg.png';
//import Airplane from '../images/b2.jpg';

export default function Team(){
    return(
        <div>
            <div className="row team" style={{border: "1px solid blue", fontSize: "20px"}}>
                <div className="col-sm-6 p-5 text-center" style={{backgroundColor: "rgba(255,255,255,0.85)"}}>
                    <div>
                        <img src={Logo} width="40%" alt="3 Keys Logo" style={{borderRadius:"50%", backgroundColor:"blue"}} />
                        <br />
                        <p className="text-dark">Oladapo Adeyemi,
                        C.E.O.<br /><span style={{fontSize:"15px"}}>Tel: 07067370051, 08177582762<br />oluyemi@3keyslogistics.com</span></p>
                    </div>
                    <p style={{textAlign: "justify"}}>
                        3 Keys Logistics Limited was duly registered under the CAC as a limited liability company in the year 2024. It is licensed to carry logistics and transportation business within the shores of Nigeria as well as across the borders.
                    </p>
                </div>
                <div className="col-sm-6 p-5 text-white" style={{textAlign: "justify", backgroundColor: "rgba(0,0,255, 0.6)"}}>
                    
                    <p>
                        The company is founded by Mr Oladapo Adeyemi. He is also serving as the CEO of the organisation. He has put in much experience in this industry. He definitely will put his skills and experience to bear in paddling the organisation in the right direction.
                    </p>

                    <p>
                        Working with him are other qualified members who are quite passionate about the business. They are friendly and are always ready to go extra miles to satisfy their clients. The organisation is customer focused. Its policies are always for the benefit of the customers. 
                    </p>

                </div>
                
            </div>
        </div>
    );
}